import React from 'react';
import { useController } from 'react-hook-form-v7';
import CollapsibleFilterWrapper from '../CollapsibleFilterWrapper';
import CheckboxList from './CheckboxList';

const CollapsibleCheckbox = ({
    control,
    name,
    label,
    defaultValue,
    options,
    render,
    emptyLabel: emptyLabelProp,
}) => {
    const { field } = useController({ control, name, defaultValue });
    const onReset = () => field.onChange(defaultValue);
    const emptyLabel = emptyLabelProp ?? 0;
    return (
        <CollapsibleFilterWrapper
            label={`${label} (${field.value?.length ? field.value.length : emptyLabel})`}
            onReset={onReset}
        >
            <CheckboxList field={field} options={options} render={render} />
        </CollapsibleFilterWrapper>
    );
};

export default CollapsibleCheckbox;
